import CardContent from './CardContent';

export default CardContent;
